import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function GuaranteeSection() {
  return <section className="pb-20 bg-white" data-id="element-75" data-mp="4vs1604r2hrx">
      <div className="max-w-3xl mx-auto px-6" data-id="element-76" data-mp="9ucpp2an3d0j">
        <FadeIn data-id="element-77" data-mp="9tl6kqy8b7r5">
          <div className="bg-brand-light-sage border border-brand-forest border-opacity-40 rounded-2xl px-6 py-7 sm:px-8 sm:py-8" data-id="element-78" data-mp="9t1mb3l3w79y">
            <div className="flex flex-col sm:flex-row sm:items-start gap-4 sm:gap-5" data-id="element-79" data-mp="jsip9d8z4728">
              <span className="flex-shrink-0 w-11 h-11 rounded-full bg-white flex items-center justify-center" aria-hidden="true" data-id="element-80" data-mp="jqptwu3t999j">
                <ShieldCheckIcon className="w-6 h-6 text-brand-forest" data-id="element-81" data-mp="slmc2c5idw9j" />
              </span>

              <div data-id="element-82" data-mp="xjfjf8ijswbe">
                <h3 className="font-serif font-bold text-brand-forest text-lg sm:text-xl tracking-wide mb-2" data-id="element-83" data-mp="xm1qz85fvbtm">
                  GARANTÍA DE 7 DÍAS
                </h3>
                <p className="text-brand-charcoal leading-relaxed text-sm sm:text-base" data-id="element-84" data-mp="17iwih73aobye">
                  Queremos que empieces con tranquilidad. Si después de adquirir
                  «Desintoxica tu Mente en 21 Días» decides que la guía no es
                  para ti, puedes solicitar un reembolso dentro del período de
                  garantía de 7 días, de acuerdo con las condiciones de Hotmart.
                </p>
                <p className="text-xs text-brand-gray mt-3" data-id="element-85" data-mp="1ru8rboaya2y5">
                  Compra procesada de forma segura a través de Hotmart.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}